export const MIXPANEL_URL = '/mxp/event';
